import http from '@/utils/http'

export const loadStreams = (nodeID, params = {}) => http.get(`/kuiper/${nodeID}/streams`, { params })

export const viewStream = (nodeID, id) => http.get(`/kuiper/${nodeID}/streams/${id}`)

export const createStream = (nodeID, body = {}) => http.post(`/kuiper/${nodeID}/streams`, body)

export const deleteStream = (nodeID, id) => http.delete(`/kuiper/${nodeID}/streams/${id}`)

export const updateStream = (nodeID, id, body = {}) => http.put(`/kuiper/${nodeID}/streams/${id}`, body)

export default {}
